import { stylable } from '../decorators';
import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
import { getBackgroundColor } from '@intercom/embercom-prosemirror-composer/lib/config/specs/nodes/spec-util';
const stackedValues = ['true', 'false'];
let buildCssStyle = (key, value) => {
  return value ? key.concat(value, ';') : '';
};
let getAttributes = dom => {
  return {
    paddingTop: dom.style?.paddingTop,
    paddingBottom: dom.style?.paddingBottom,
    paddingLeft: dom.style?.paddingLeft,
    paddingRight: dom.style?.paddingRight,
    backgroundColor: getBackgroundColor(dom.style?.backgroundColor),
    colwidth: dom.getAttribute('data-colwidth') ? [Number(dom.getAttribute('data-colwidth'))] : null
  };
};
export const tableSpec = stylable({
  content: 'tableRow+',
  tableRole: 'table',
  isolating: true,
  attrs: {
    type: {
      default: 'table'
    },
    responsive: {
      default: false
    },
    container: {
      default: false
    },
    stacked: {
      default: undefined
    },
    sectionType: {
      default: undefined
    }
  },
  parseDOM: [{
    tag: 'table',
    getAttrs(dom) {
      return {
        responsive: dom.attributes['data-responsive'] !== undefined,
        stacked: stackedValues.includes(dom.attributes['data-stacked']) ? dom.attributes['data-stacked'] : true,
        container: dom.attributes['data-container'] !== undefined,
        sectionType: dom.attributes['data-section-type'] !== undefined ? dom.attributes['data-section-type'].nodeValue : undefined,
        backgroundColor: getBackgroundColor(dom.style?.backgroundColor)
      };
    }
  }],
  toDOM(node) {
    if (node.attrs.container) {
      let sectionType = node.attrs.sectionType || '';
      return ['div', {
        class: `${BLOCK_CLASSES.blockContainer} ${BLOCK_CLASSES.table} embercom-prosemirror-composer-section`
      }, ['div', {
        class: 'section-type'
      }, sectionType], ['table', {
        class: 'container intercom-template-content',
        'data-container': 'true',
        'data-section-type': sectionType,
        style: `${buildCssStyle('background-color: ', node.attrs.backgroundColor)}`
      }, ['tbody', 0]]];
    }
    if (node.attrs.responsive) {
      return ['div', {
        class: `${BLOCK_CLASSES.blockContainer} ${BLOCK_CLASSES.table} embercom-prosemirror-composer-layout`
      }, ['table', {
        class: 'row intercom-responsive-layout-table',
        'data-responsive': 'true',
        'data-stacked': typeof node.attrs.stacked === 'boolean' ? node.attrs.stacked.toString() : ''
      }, ['tbody', 0]]];
    }
    return ['div', {
      class: `${BLOCK_CLASSES.blockContainer} ${BLOCK_CLASSES.table}`
    }, ['table', ['tbody', 0]]];
  }
});
export const tableRowSpec = {
  content: 'tableCell+',
  tableRole: 'row',
  parseDOM: [{
    tag: 'tr'
  }],
  toDOM() {
    return ['tr', 0];
  }
};
export const tableCellSpec = stylable({
  content: '(block | list)+',
  tableRole: 'cell',
  isolating: true,
  parseDOM: [{
    tag: 'td',
    getAttrs(dom) {
      return getAttributes(dom);
    }
  }, {
    tag: 'th',
    getAttrs(dom) {
      return getAttributes(dom);
    }
  }],
  attrs: {
    colspan: {
      default: 1
    },
    rowspan: {
      default: 1
    },
    colwidth: {
      default: null
    },
    responsiveClasses: {
      default: ''
    },
    container: {
      default: false
    }
  },
  toDOM(node) {
    if (node.attrs.responsiveClasses) {
      return ['td', {
        'data-insertable': 'true',
        class: node.attrs.responsiveClasses
      }, 0];
    }
    let colwidth = node.attrs.colwidth?.length > 0 ? node.attrs.colwidth[0] : null;
    return ['td', {
      'data-insertable': 'true',
      'data-colwidth': colwidth || undefined
    }, 0];
  }
});